/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Icon/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import CreatePaymentPlan from './CreatePaymentPlan/index'
import CreateTreatmentPlan from './CreateTreatmentPlan/index'
import No from './No/index'
import React from 'react'
import ResumePaymentPlan from './ResumePaymentPlan/index'
import ResumeTreatmentPlan from './ResumeTreatmentPlan/index'
import StartContract from './StartContract/index'
import ViewCaseCloserRequest from './ViewCaseCloserRequest/index'



/** @type {import('Simple/types.js').View} */
export default function Icon({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Summary/Content/Content/TreatmentPlanStatus/Content/Content/Icon"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let treatmentCardTxsTreatmentPlanActionValueData = fromData.useDataValue({ viewPath,
context: 'treatment_card',
path: 'txs.treatment_plan_action',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: treatmentCardTxsTreatmentPlanActionValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CreateTreatmentPlan'}>
<CreateTreatmentPlan
  viewPath={`${viewPath}/CreateTreatmentPlan`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ResumeTreatmentPlan'}>
<ResumeTreatmentPlan
  viewPath={`${viewPath}/ResumeTreatmentPlan`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CreatePaymentPlan'}>
<CreatePaymentPlan
  viewPath={`${viewPath}/CreatePaymentPlan`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ResumePaymentPlan'}>
<ResumePaymentPlan
  viewPath={`${viewPath}/ResumePaymentPlan`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'StartContract'}>
<StartContract
  viewPath={`${viewPath}/StartContract`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ViewCaseCloserRequest'}>
<ViewCaseCloserRequest
  viewPath={`${viewPath}/ViewCaseCloserRequest`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}